/** Event name only — keep here so `Dashboard` does not import `ModuleRouteOnboardingHost` at module init. */
export const FIRST_LOGIN_ALL_MODULES_ONBOARDING_EVENT =
  "erp-first-login-all-modules-onboarding";

const WELCOME_TOUR_AFTER_LOGIN_SESSION_KEY = "erp_welcome_tour_after_login_v1";

/** Call after successful password login (not on every page load). */
export function markWelcomeTourExpectedAfterLogin() {
  try {
    window.sessionStorage.setItem(WELCOME_TOUR_AFTER_LOGIN_SESSION_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function peekWelcomeTourExpectedAfterLogin() {
  try {
    return window.sessionStorage.getItem(WELCOME_TOUR_AFTER_LOGIN_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearWelcomeTourExpectedAfterLogin() {
  try {
    window.sessionStorage.removeItem(WELCOME_TOUR_AFTER_LOGIN_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/** Latest consumer from `ModuleRouteOnboardingHost`. */
let firstLoginTourDetailHandler = null;

/**
 * If `Dashboard` dispatches the welcome tour before the host has registered (same tick /
 * microtask ordering), hold the payload and deliver it when {@link setFirstLoginTourDetailHandler}
 * runs.
 */
let pendingFirstLoginTourDetail = null;

export function setFirstLoginTourDetailHandler(fn) {
  firstLoginTourDetailHandler = typeof fn === "function" ? fn : null;
  /**
   * Do not clear `pendingFirstLoginTourDetail` when the handler is torn down: the welcome
   * event can fire after unmount (microtask / deferred dispatch) and would be lost if we wiped
   * the buffer here. Pending is cleared only when consumed below or overwritten by a new event.
   */
  if (firstLoginTourDetailHandler && pendingFirstLoginTourDetail) {
    const detail = pendingFirstLoginTourDetail;
    pendingFirstLoginTourDetail = null;
    try {
      firstLoginTourDetailHandler(detail);
    } catch {
      /* ignore */
    }
  }
}

/**
 * Deliver the welcome / first-login tour payload synchronously (same buffering as the window
 * listener). Prefer this over {@link FIRST_LOGIN_ALL_MODULES_ONBOARDING_EVENT} from `Dashboard`
 * so timing does not depend on custom events.
 */
export function offerFirstLoginTourDetail(detail) {
  installFirstLoginTourWindowListenerOnce();
  try {
    if (firstLoginTourDetailHandler) {
      firstLoginTourDetailHandler(detail);
    } else {
      pendingFirstLoginTourDetail = detail;
    }
  } catch {
    /* ignore */
  }
}

function installFirstLoginTourWindowListenerOnce() {
  if (typeof window === "undefined") return;
  if (window.__ERP_FIRST_LOGIN_TOUR_WINDOW_V1__) return;
  window.__ERP_FIRST_LOGIN_TOUR_WINDOW_V1__ = true;
  window.addEventListener(FIRST_LOGIN_ALL_MODULES_ONBOARDING_EVENT, (e) => {
    try {
      const detail = e?.detail;
      if (firstLoginTourDetailHandler) {
        firstLoginTourDetailHandler(detail);
      } else {
        pendingFirstLoginTourDetail = detail;
      }
    } catch {
      /* ignore */
    }
  });
}

installFirstLoginTourWindowListenerOnce();
